import { create } from 'zustand';

interface AppState {
  /** Whether the WebSocket connection is active. */
  isConnected: boolean;
  /** Clerk user ID of the currently authenticated user. */
  currentUserId: string | null;

  setConnected: (connected: boolean) => void;
  setCurrentUserId: (userId: string | null) => void;
}

export const useAppStore = create<AppState>((set) => ({
  isConnected: false,
  currentUserId: null,
  setConnected: (connected) => set({ isConnected: connected }),
  setCurrentUserId: (userId) => set({ currentUserId: userId }),
}));
